import {useCallback} from 'react'

import {convertBskyAppUrlForLink} from '#/lib/strings/url-helpers'
import {useSunnahskyDids} from '#/state/queries/sunnahsky-dids'

/**
 * The navigation-aware form of `convertBskyAppUrlIfNeeded` - see
 * `convertBskyAppUrlForLink`'s own doc comment for why this is a separate
 * function rather than a parameter on the shared one. `sunnahskyDids` (and
 * therefore the returned callback) is `undefined` until `useSunnahskyDids()`
 * resolves; `dids` in the dependency array is load-bearing, not incidental -
 * omitting it would keep serving whichever value was captured at mount.
 */
export function useConvertUrl() {
  const {data: sunnahskyDids} = useSunnahskyDids()
  return useCallback(
    (url: string) => convertBskyAppUrlForLink(url, sunnahskyDids),
    [sunnahskyDids],
  )
}
